/**
 * PageRenderer — renders a page's sections in array order (the single source of
 * ordering), visible ones only. Knows nothing about section internals.
 */
import type { Page } from '../schema'
import { SectionRenderer } from './SectionRenderer'

export function PageRenderer({ page }: { readonly page: Page }) {
  return (
    <>
      {page.sections
        .filter((section) => section.visible !== false)
        .map((section) => (
          <SectionRenderer key={section.id} section={section} />
        ))}
    </>
  )
}
